export default "__VITE_ASSET___ZSboMc3__"